import React from "react";
interface DetailedMeasuresCounterProps {
  title: string;
  data: {
    currentQuarter?: number;
    quarterly?: number;
    continuous?: number;
    untilEU?: number;
    total: number;
  };
  colorScheme: "blue" | "green" | "red" | "orange";
  subtitle?: string;
  unrealised?: boolean;
  isSecond?: boolean;
}

const DetailedMeasuresCounter: React.FC<DetailedMeasuresCounterProps> = ({
  title,
  data,
  colorScheme,
  subtitle,
  unrealised = false,
  isSecond = false,
}) => {
  const getColorClasses = () => {
    switch (colorScheme) {
      case "blue":
        return {
          bgClass: "bg-[#F0F9FF] border border-[#BFDBFE]",
          numberClass: "text-[#1D4ED8]",
          textClass: "text-[#374151]",
          subTextClass: "text-[#6B7280]",
        };
      case "green":
        return {
          bgClass: "bg-[#F0FDF4] border border-[#BBF7D0]",
          numberClass: "text-[#166534]",
          textClass: "text-[#374151]",
          subTextClass: "text-[#6B7280]",
        };
      case "red":
        return {
          bgClass: "bg-[#FEF2F2] border border-[#FECACA]",
          numberClass: "text-[#DC2626]",
          textClass: "text-[#374151]",
          subTextClass: "text-[#6B7280]",
        };
      case "orange":
        return {
          bgClass: "bg-[#FFFBEB] border border-[#FED7AA]",
          numberClass: "text-[#EA580C]",
          textClass: "text-[#374151]",
          subTextClass: "text-[#6B7280]",
        };
    }
  };

  const { bgClass, numberClass, textClass, subTextClass } = getColorClasses();

  return (
    <div
      className={`px-4 py-3 flex flex-col ${bgClass} rounded-[8px] ${
        unrealised ? "justify-between" : ""
      }`}
    >
      {unrealised ? (
        <div className="flex flex-col">
          <span className={`font-bold text-[16px] ${textClass} mb-2`}>
            {title}
          </span>
          {subtitle && (
            <span className={`${subTextClass} text-[12px] mb-3`}>
              {subtitle}
            </span>
          )}
        </div>
      ) : (
        <>
          <span className={`font-bold text-[16px] ${textClass} mb-2`}>
            {title}
          </span>
          {subtitle && (
            <span className={`${subTextClass} text-[12px] mb-3`}>
              {subtitle}
            </span>
          )}
        </>
      )}

      <div className="flex flex-col gap-1">
        {data.currentQuarter !== undefined && (
          <div className="flex justify-between items-center">
            <span className={`text-[13px] ${textClass}`}>Кварталне:</span>
            <span className={`font-semibold text-[16px] ${numberClass}`}>
              {data.currentQuarter}
            </span>
          </div>
        )}
        {data.quarterly !== undefined && (
          <div className="flex justify-between items-center">
            <span className={`text-[13px] ${textClass}`}>
              Кварталне:
            </span>
            <span className={`font-semibold text-[16px] ${numberClass}`}>
              {data.quarterly}
            </span>
          </div>
        )}
        {data.continuous !== undefined && (
          <div className="flex justify-between items-center">
            <span className={`text-[13px] ${textClass}`}>Континуиране:</span>
            <span className={`font-semibold text-[16px] ${numberClass}`}>
              {data.continuous}
            </span>
          </div>
        )}
        {data.untilEU !== undefined && (
          <div className="flex justify-between items-center">
            <span className={`text-[13px] ${textClass}`}>
              До приступања ЕУ:
            </span>
            <span className={`font-semibold text-[16px] ${numberClass}`}>
              {data.untilEU}
            </span>
          </div>
        )}
        <div className="flex justify-between items-center mt-2 pt-2 border-t border-gray-300">
          <span className={`text-[14px] font-semibold ${textClass}`}>
            Укупно:
          </span>
          <span className={`font-bold text-[20px] ${numberClass}`}>
            {data.total}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DetailedMeasuresCounter;
